export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}/apiv1`
    : 'http://localhost:8083'

export const DEFAULT_REDIRECT_URL = process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'https://nightly.xeba.ir'

export const GATEWAY_BASE_URL = process.env.VUE_APP_API_URL ? `${process.env.VUE_APP_API_URL}/gateway/apiv1` : 'https://nightly.xeba.ir/gateway/apiv1'

export const DOLPHIN_BASE_URL = process.env.VUE_APP_API_URL ? `${process.env.VUE_APP_API_URL}/dolphin/apiv1` : 'https://nightly.xeba.ir/dolphin/apiv1'

export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID

export const GOOGLE_OAUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth'

export const DEFAULT_SCOPES = [
  'title',
  'email',
  'avatar',
  'firstName',
  'lastName',
  'phone',
  'countryCode'
]

export const DEFAULT_APPLICATION_ID = 1
